import React from "react";
import cadreVoiture from "./cadre/cadreVoiture.png";
import cadreVelo from "./cadre/cadreVelo.png";
import cadrePedestre from "./cadre/cadrePedestre.png";
import cadreVoitureAudio from "./cadre/cadreVoitureAudio.png";
import cadreVeloAudio from "./cadre/cadreVeloAudio.png";
import cadrePedestreAudio from "./cadre/cadrePedestreAudio.png";
import cadreVoiturePartielPayant from "./cadre/cadreVoiturePartielPayant.png";
import cadreAVoiturePartielPayant from "./cadre/cadreAVoiturePatielPayant.png";
import cadreAVeloPartielPayant from "./cadre/cadreAVeloPartielPayant.png";
import cadreVeloPartielPayant from "./cadre/cadreVeloPartielPayant.png";
import cadrePayant from "./cadre/cadrePayant.png";
import cadreAudioPayant from "./cadre/cadreAudioPayant.png";
import cadreAPedestrePartielPayant from "./cadre/cadreAPedestrePartielPayant.png";
import cadrePedestrePartielPayant from "./cadre/cadrePedestrePartielPayant.png";
import "../../style/Marker.css";
import { parcoursTypes } from "../../map/GPX/Resources";

const MarkerIcon = ({
  componentType,
  projectDatas,
  markerAccesValue,
  markerIcon,
  iconNameWithoutBorder,
  marker,
}) => {
  const serverIcon = (marker.media || []).find(
    (media) => media.mediaType === "icon" && media.url
  );
  const localPreview =
    typeof markerIcon === "string" && markerIcon.startsWith("data:")
      ? markerIcon
      : null;
  const legacyIcon =
    typeof markerIcon === "string" && markerIcon.length > 0
      ? markerIcon
      : null;
  const url_icon =
    localPreview ||
    serverIcon?.url ||
    legacyIcon ||
    `https://raw.githubusercontent.com/mcharef22/icons/main/${
    marker.id
  }${
    iconNameWithoutBorder ? iconNameWithoutBorder : marker.iconNameWithoutBorder
  }`;
  const FREE_ACCESS = "Gratuit";
  const PARTIALLY_PAID_ACCESS = "Partiellement payant";
  const PAID_ACCESS = "Payant";
  return (
    <>
      <div id="marker-icon" className="markerIconWithBorder">
        <img
          src={
            componentType === "Information"
              ? projectDatas.projectType === parcoursTypes.car
                ? marker.checkAcces === FREE_ACCESS
                  ? cadreVoiture
                  : marker.checkAcces === FREE_ACCESS
                  ? cadreVoitureAudio
                  : marker.checkAcces === PARTIALLY_PAID_ACCESS
                  ? cadreVoiturePartielPayant
                  : marker.checkAcces === PARTIALLY_PAID_ACCESS
                  ? cadreAVoiturePartielPayant
                  : marker.checkAcces === PAID_ACCESS
                  ? cadrePayant
                  : marker.checkAcces === PAID_ACCESS
                  ? cadreAudioPayant
                  : cadreVoitureAudio
                : projectDatas.projectType === parcoursTypes.cycle
                ? marker.checkAcces === FREE_ACCESS
                  ? cadreVelo
                  : marker.checkAcces === FREE_ACCESS
                  ? cadreVeloAudio
                  : marker.checkAcces === PARTIALLY_PAID_ACCESS
                  ? cadreVeloPartielPayant
                  : marker.checkAcces === PARTIALLY_PAID_ACCESS
                  ? cadreAVeloPartielPayant
                  : marker.checkAcces === PAID_ACCESS
                  ? cadrePayant
                  : marker.checkAcces === PAID_ACCESS
                  ? cadreAudioPayant
                  : cadreVeloAudio
                : projectDatas.projectType === parcoursTypes.pedestrian
                ? marker.checkAcces === FREE_ACCESS
                  ? cadrePedestre
                  : marker.checkAcces === FREE_ACCESS
                  ? cadrePedestreAudio
                  : marker.checkAcces === PARTIALLY_PAID_ACCESS
                  ? cadrePedestrePartielPayant
                  : marker.checkAcces === PARTIALLY_PAID_ACCESS
                  ? cadreAPedestrePartielPayant
                  : marker.checkAcces === PAID_ACCESS
                  ? cadrePayant
                  : marker.checkAcces === PAID_ACCESS
                  ? cadreAudioPayant
                  : cadrePedestreAudio
                : null
              : projectDatas.projectType === parcoursTypes.car
              ? markerAccesValue === FREE_ACCESS
                ? cadreVoiture
                : markerAccesValue === FREE_ACCESS
                ? cadreVoitureAudio
                : markerAccesValue === PARTIALLY_PAID_ACCESS
                ? cadreVoiturePartielPayant
                : markerAccesValue === PARTIALLY_PAID_ACCESS
                ? cadreAVoiturePartielPayant
                : markerAccesValue === PAID_ACCESS
                ? cadrePayant
                : markerAccesValue === PAID_ACCESS
                ? cadreAudioPayant
                : cadreVoitureAudio
              : projectDatas.projectType === parcoursTypes.cycle
              ? markerAccesValue === FREE_ACCESS
                ? cadreVelo
                : markerAccesValue === FREE_ACCESS
                ? cadreVeloAudio
                : markerAccesValue === PARTIALLY_PAID_ACCESS
                ? cadreVeloPartielPayant
                : markerAccesValue === PARTIALLY_PAID_ACCESS
                ? cadreAVeloPartielPayant
                : markerAccesValue === PAID_ACCESS
                ? cadrePayant
                : markerAccesValue === PAID_ACCESS
                ? cadreAudioPayant
                : cadreVeloAudio
              : projectDatas.projectType === parcoursTypes.pedestrian
              ? markerAccesValue === FREE_ACCESS
                ? cadrePedestre
                : markerAccesValue === FREE_ACCESS
                ? cadrePedestreAudio
                : markerAccesValue === PARTIALLY_PAID_ACCESS
                ? cadrePedestrePartielPayant
                : markerAccesValue === PARTIALLY_PAID_ACCESS
                ? cadreAPedestrePartielPayant
                : markerAccesValue === PAID_ACCESS
                ? cadrePayant
                : markerAccesValue === PAID_ACCESS
                ? cadreAudioPayant
                : cadrePedestreAudio
              : null
          }
          alt="Image de cadre"
          className="cadreIcon"
        />

        <img src={url_icon} alt="Image téléchargée" className="iconMarker" />
      </div>
    </>
  );
};
export default MarkerIcon;
